import angular from 'angular';
import 'ng-file-upload';

const productsServices = angular.module('applicationModule.productsServices', []);

productsServices.factory('Product', ['ProductsAPI', 'AppsoupAPI', '$q', (ProductsAPI, AppsoupAPI, $q) => {
    'use strict';
    return {
        isImage: (src) => {
            const deferred = $q.defer();
            const image = new Image();

            image.onerror = () => {
                deferred.resolve(false);
            };
            image.onload = () => {
                deferred.resolve(true);
            };
            image.src = src;

            return deferred.promise;
        },
        getList: (appId, params) => {
            return ProductsAPI.getProducts(appId, params)
                .then((response) => {
                    return response.data;
                });
        },
        get: (productId, appId) => {
            return ProductsAPI.getProduct(productId, appId);
        },
        save: (product, editMode) => {
            if (editMode) {
                return ProductsAPI.editProduct(product);
            } else {
                return ProductsAPI.createProduct(product);
            }
        },
        importProducts: (appId, file, mergeType) => {
            return ProductsAPI.importProducts(appId, file, mergeType);
        },
        remove: (productId, appId) => {
            return ProductsAPI.removeProduct(productId, appId);
        },
        removeChecked: (checkedProducts, appId) => {
            return ProductsAPI.removeChecked(checkedProducts, appId);
        },
        categories: (appId, text) => {
            return ProductsAPI.getCategories(appId, text);
        },
        massiveActionCategory: (productsData) => {
            return ProductsAPI.setMassiveCategory(productsData);
        },
        getPromotions: (productId) => {
            return ProductsAPI.getPromotions(productId);
        },
        getAttribute: (appId, moduleType) => {
            return ProductsAPI.getAttribute(appId, moduleType);
        },
        generateCSV: (appId, hours) => {
            return ProductsAPI.generateCSV(appId, hours);
        },
        getImage: (productId, ean) => {
            return ProductsAPI.getImage(productId, ean);
        },
        getStatusLabels: (appId) => {
            return ProductsAPI.getStatusLabels(appId);
        },
        searchShop: (appId, search) => {
            return ProductsAPI.searchShop(appId, search);
        },
        publish: (appId, productIds) => {
            return ProductsAPI.publish(appId, productIds);
        }
    };
}]);

productsServices.service('ProductsAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';
    const API_URL = AppsoupAPI.API_URL + '/app/product/';

    this.getProducts = (appId, params) => {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };
    this.createProduct = (product) => {
        return $http.post(API_URL, product);
    };
    this.getProduct = (productId, appId) => {
        return $http.get(API_URL + productId, {params: {application_id: appId}});
    };
    this.editProduct = (product) => {
        return $http.put(API_URL + product.id, product);
    };
    this.setMassiveCategory = (productsData) => {
        return $http.post(API_URL + 'checked/edit', productsData);
    };
    this.removeChecked = (checkedProducts, appId) => {
        return $http.post(API_URL + 'checked/delete', {checkedProducts: checkedProducts, appId: appId});
    };
    this.removeProduct = (productId, appId) => {
        return $http.delete(API_URL + productId + '/' + appId);
    };
    this.getCategories = (appId, text) => {
        return $http.get(API_URL + 'categories/' + appId, {params: {search: text}});
    };
    this.getPromotions = (productId) => {
        return $http.get(API_URL + 'promotions/' + productId);
    };
    this.getAttribute = (appId, moduleType) => {
        return $http.get(API_URL + appId + '/module/' + moduleType);
    };
    this.generateCSV = (appId, hours) => {
        return $http.post(API_URL + 'product-export/', {application_id: appId, hours: hours});
    };
    this.importProducts = (appId, file, mergeType) => {
        if (angular.isDefined(file)) {
            return Upload.upload({
                url: API_URL + 'import',
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: {
                    application_id: appId,
                    merge_type: mergeType
                },
                file: file
            });
        }
    };
    this.getImage = (productId, ean) => {
        return $http.get(API_URL + productId + '/get-image/' + ean);
    };

    this.getStatusLabels = (appId) => {
        return $http.get(API_URL + appId + '/status-labels');
    };

    this.searchShop = (appId, text) => {
        return $http.get(API_URL + appId + '/shops', {params: {search: text}});
    };
    this.publish = (appId, productIds) => {
        return $http.post(API_URL + appId + '/publish', {product_ids: productIds});
    };
}]);

productsServices.service('ProductGallery', ['ProductGalleryAPI', function (ProductGalleryAPI) {
    'use strict';
    return {
        get: (productId) => {
            return ProductGalleryAPI.getGallery(productId);
        },
        remove: (productId, appid, imageId) => {
            return ProductGalleryAPI.remove(productId, appid, imageId);
        }
    };
}]);

productsServices.service('ProductGalleryAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';
    const API_URL = AppsoupAPI.API_URL + '/app/product/gallery/';

    this.getGallery = (productId) => {
        return $http.get(API_URL + productId);
    };
    this.remove = (productId, appId, imageId) => {
        return $http.delete(API_URL + productId + '/' + appId + '/' + imageId);
    };
}]);

export default productsServices;
